module.exports = __webpack_public_path__ + "img/logo_pcarelab.4eda8144.png";